<template>
  <div>
    <div class="w-full overflow-x-scroll">
      <table class="w-full">
        <thead class="text-xs uppercase border-t border-b">
          <th class="py-3 px-2 text-left">File Name</th>
          <th class="py-3 px-2">Select</th>
        </thead>
        <tbody>
          <tr
            v-for="(anim, index) in logoItems"
            :key="index"
            class="border-b"
            :class="{
            'bg-blue-lightest': index % 2 === 0
          }"
          >
            <td class="py-6 px-2">
              <div class="flex items-center capitalize">
                <div class="box border border-primary overflow-hidden mr-4 hidden md:block">
                  <video
                    width="160"
                    height="90"
                    loop
                    @mouseenter="$event.target.play()"
                    @mouseleave="$event.target.currentTime = 2; $event.target.pause();"
                  >
                    <source
                      :src="anim.path"
                      type="video/mp4"
                    >
                  </video>
                </div>
                {{ anim.title }}
              </div>
            </td>
            <td class="py-6 px-2 text-center">
              <input
                :id="'anim_' + index"
                type="radio"
                class="blue"
                :value="anim"
                v-model="preference"
              />
              <label
                :for="'anim_' + index"
                class="bg-white"
              ></label>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mt-6">
        <button class="bg-tertiary font-bold rounded flex items-center w-48 pl-4 py-1" @click="showModal = true">
          <icon
            name="videoettes"
            class="w-8 text-white"
            :center="false"
          />
          <span class="text-sm text-primary font-thin text-white bg-tertiary ml-3">Upload Custom</span>
        </button>
      </div>
    </div>
    <custom-logo-animation-modal :showModal="showModal" @close="showModal = false" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CustomLogoAnimationModal from './CustomLogoAnimationModal.vue'
export default {
  components: { CustomLogoAnimationModal },
  name: 'LogoAnimation',

  props: ['value'],

  data () {
    return {
      'showModal': false
    }
  },

  computed: {
    ...mapState({
      logoItems: state => state.videoettes.logoItems
    }),

    preference: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>
/* Margin right is defined globally, won't change so resetting here instead so we can have a white background.*/
input[type="radio"] + label::before {
  margin-right: 0;
}

.box {
  width: 160px;
  height: 90px;
}

.image-preview {
  width: 8em;
  height: 4.5em;
}
</style>
